import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const ThumbsUp = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "M15.54 3.054c0-.862 0-1.804-1.787-1.804-.927 0-1.131.496-1.483 1.348-.328.796-.784 1.902-2.076 3.206l-.236.237c-.818.818-1.623 1.622-1.623 2.45v7.205s.07 1.804 1.859 1.804h7.16c.77 0 1.396-.67 1.396-1.45 0-.608-.383-1.13-.921-1.325.538-.196.921-.717.921-1.325s-.383-1.13-.921-1.325c.538-.196.921-.717.921-1.325s-.383-1.13-.921-1.325c.538-.196.921-.717.921-1.325 0-.78-.625-1.412-1.396-1.412h-3.58s1.767-.925 1.767-3.634ZM4.951 8.333H3.038s-1.788 0-1.788 1.804v5.559s0 1.804 1.788 1.804H4.88s1.788 0 1.788-1.804v-5.559s.016-1.804-1.718-1.804Z" }) }));
});
ThumbsUp.displayName = 'ThumbsUp';
export default ThumbsUp;
//# sourceMappingURL=ThumbsUp.js.map